<div class="container-fluid cadastro-perfil">
    <mat-card>
        <mat-card-header class="header-padrao">
            <mat-card-title>
                Gerencia de arquivos
                <button class="float-right" mat-flat-button color="primary" (click)="openNovo()" [ngStyle]="{ margin: '-6px' }">
                    Novo <i class="fas fa-plus" style="font-size: 12px;"></i>
                </button>

                <div class="tab-pane" id="tab-nrt" role="tabpanel" aria-labelledby="tab-nrt-tab">
                    <form [formGroup]="form">
                        <input-pesquisa-cliente (valorSelecionado)="clienteSelecionado($event)" [control]="$any(form.get('cliente'))"></input-pesquisa-cliente>
                    </form>
                </div>

            </mat-card-title>
        </mat-card-header>

        <mat-progress-bar color="primary" mode="indeterminate" *ngIf="isLoading"></mat-progress-bar>

        <div *ngIf="listaArquivos.length == 0" style="min-height: 120px" class="d-flex align-items-center justify-content-center">
            <span>Nenhum registro para o filtro especificado.</span>
        </div>

        <mat-card-content *ngIf="listaArquivos.length > 0">
            <div>
                <table id="relatorios" mat-table [dataSource]="listaArquivos" class="table">
                    <tbody>

                        <ng-container matColumnDef="nomeArquivo">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;" style="text-align: center;">Nome arquivo
                            </th>
                            <td mat-cell *matCellDef="let p">{{ p?.nomeArquivo }}</td>
                        </ng-container>

                        <ng-container matColumnDef="usuario">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Usuario</th>
                            <td mat-cell *matCellDef="let p">{{ p?.usuario }}</td>
                        </ng-container>

                        <ng-container matColumnDef="dataUpload">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Upload</th>
                            <td mat-cell *matCellDef="let p">{{ p?.dataUpload | date:'dd/MM/yyyy hh:mm' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef style="text-align: center;">Ações</th>
                            <td mat-cell *matCellDef="let p" width="100px">
                                <button mat-icon-button [matMenuTriggerFor]="menu" aria-label="Example icon-button with a menu">
                                    <mat-icon>more_vert</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu">
                                    <button mat-menu-item (click)="openAtualizaArquivo(p?.id)" color="primary">
                                        <mat-icon fontSet="fas" fontIcon="fa-edit"></mat-icon>
                                        <span>Atualiza Arquivo</span>
                                    </button>
                                    <button mat-menu-item (click)="openPermissao(p?.id)" color="primary">
                                        <mat-icon fontSet="fas" fontIcon="fa-edit"></mat-icon>
                                        <span>Permissão</span>
                                    </button>
                                    <button mat-menu-item (click)="remove(p?.id)" color="primary">
                                        <mat-icon fontSet="fas" fontIcon="fa-times"></mat-icon>
                                        <span>Deletar</span>
                                    </button>
                                </mat-menu>
                            </td>
                        </ng-container>




                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
                    </tbody>
                </table>
            </div>

        </mat-card-content>
    </mat-card>
</div>
